import React from 'react';
import { Table, Container, Input, Row, Col, Button } from 'reactstrap';
import { NumberWithCommas } from "../../share/NumberWithCommas";
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import "./Reports.css"
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report192() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear())
    const [six, setSix] = React.useState([
        {
            year: '',
            target: '',
            month: '',
            budgetAmount: '',
            meetingNo: '',
            meetingDate: '',
            amtBorrowCompany: '',
            amtBorrow: '',
            amtApproveCompany: '',
            amtApprove: '',
            remainApprove: '',
            amtContactCompany: '',
            amtContact: '',
            remainContact: '',
            updateDate: '',
        }
    ])
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNewn BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }

    const [Re192yeardata, setRe192yeardata] = React.useState([]);
    async function getR192year() {
        const res = await fetch("/api/BorrowReports/getyear192")
        const Re192yeardata = await res.json()
        setRe192yeardata(Re192yeardata.dataenum)
        // console.log(Re192yeardata)
    }

    React.useEffect(() => {
        GetV192ApproveContact()
        getR192year()
    }, [thYearSelected]);

    async function GetV192ApproveContact() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV192", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        // console.log(data)
        setSix(data.dataenum)
        // console.log(data)
    }
    




    let sumAmtBorrowCompany = six.reduce(function (prev, current) {
        return prev + +current.amtBorrowCompany
    }, 0);
    let sumAmtBorrow = six.reduce(function (prev, current) {
        return prev + +current.amtBorrow
    }, 0);
    let sumAmtApproveCompany = six.reduce(function (prev, current) {
        return prev + +current.amtApproveCompany
    }, 0);
    let sumAmtApprove = six.reduce(function (prev, current) {
        return prev + +current.amtApprove
    }, 0);
    let sumRemainApprove = six.reduce(function (prev, current) {
        return prev + +current.remainApprove
    }, 0);
    let sumAmtContactCompany = six.reduce(function (prev, current) {
        return prev + +current.amtContactCompany
    }, 0);
    let sumAmtContact = six.reduce(function (prev, current) {
        return prev + +current.amtContact
    }, 0);
    let sumRemainContact = six.reduce(function (prev, current) {
        return prev + +current.remainContact
    }, 0);


    let sumAmtApproveCompany100 = sumAmtApproveCompany / sumAmtBorrowCompany * 100
    let sumAmtApprove100 = sumAmtApprove / sumAmtBorrow * 100
    let sumRemainApprove100 = sumRemainApprove / sumAmtBorrow * 100
    let sumAmtContactCompany100 = sumAmtContactCompany / sumAmtBorrowCompany * 100
    let sumAmtContact100 = sumAmtContact / sumAmtBorrow * 100
    let sumAemainContact100 = sumRemainContact / sumAmtBorrow * 100

    // console.log(sumAmtApproveCompany100)
    // console.log(sumAmtApprove100)
    // console.log(sumRemainApprove100)
    // console.log(sumAmtContactCompany100)
    // console.log(sumAmtContact100)
    // console.log(sumAemainContact100)

    return (
        <Container>
            <div>
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ประจำปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-one-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {/* <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option> */}
                        {Re192yeardata?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh+543}
                            </option>

                        ))}
                     
                    </Input>
                </div>
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV192?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR192?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>
                <div className="report-wrapper">
                    <Table className="styled-table text-center" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th colSpan="2" className='text-center'>
                                    เป้าหมายปีงบประมาณ พ.ศ. {Number(thYearSelected) + 543}
                                </th>
                                <th colSpan="2" className='text-center'>
                                    ประชุมอนุกรรมการพิจารณาเงินกู้ฯ
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    คำขอกู้
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    อนุมัติ
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    ทำสัญญา
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center' style={{ width: '100px' }}>
                                    เดือน
                                </th>

                                <th className='text-center'>
                                    จำนวนเงินงบประมาณ(บาท)
                                </th>
                                <th className='text-center'>
                                    ครั้งที่
                                </th>
                                <th className='text-center'>
                                    วันที่
                                </th>
                                <th className='text-center'>
                                    บริษัท
                                </th>
                                <th className='text-center'>
                                    จำนวน(บาท)
                                </th>
                                <th className='text-center'>
                                    บริษัท
                                </th>
                                <th className='text-center'>
                                    จำนวน(บาท)
                                </th>
                                <th className='text-center'>
                                    คงเหลืองบประมาณจากอนุมัติ
                                </th>
                                <th className='text-center'>
                                    บริษัท
                                </th>
                                <th className='text-center'>
                                    จำนวน(บาท)
                                </th>
                                <th className='text-center'>
                                    คงเหลืองบประมาณจากการทำสัญญา
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">
                                    เงินให้กู้ยืม
                                </th>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                                <td className='text-center'>

                                </td>
                            </tr>
                            {six.map(item => (
                                <tr>
                                    <th scope="row" className='text-start'>
                                        {item.monthTh + ' ' + (Number(thYearSelected) + 543)}
                                    </th>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.budgetAmount)}
                                    </td>
                                    <td className='text-end'>
                                        {item.meetingNo}
                                    </td>
                                    <td className='text-end'>
                                        {item.meetingDate}
                                    </td>
                                    <td className='text-end'>
                                        {item.amtBorrowCompany}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.amtBorrow)}
                                    </td>
                                    <td className='text-end'>
                                        {item.amtApproveCompany}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.amtApprove)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.remainApprove)}
                                    </td>
                                    <td className='text-end'>
                                        {item.amtContactCompany}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.amtContact)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.remainContact)}
                                    </td>
                                </tr>
                            ))}
                            
                        </tbody>
                        <tfoot className='table-tfoot-style'>
                            <tr>
                                <th colSpan="6" className='text-end'>
                                    ร้อยละ
                                </th>
                                <td className='text-end'>
                                    {sumAmtApproveCompany100.toFixed(0)}%
                                </td>
                                <td className='text-end'>
                                    {sumAmtApprove100.toFixed(0)}%
                                </td>
                                <td className='text-end'>
                                    {sumRemainApprove100.toFixed(0)}%
                                </td>
                                <td className='text-end'>
                                    {sumAmtContactCompany100.toFixed(0)}%
                                </td>
                                <td className='text-end'>
                                    {sumAmtContact100.toFixed(0)}%
                                </td>
                                <td className='text-end'>
                                    {sumAemainContact100.toFixed(0)}%
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </div>


                {/* <CreateTable columns={consultTbacolumns} data={consultTbRow} footer={true} /> */}

                <tr className=' d-flex justify-content-end'>
                    ข้อมูล ณ วันที่ {six[0]?.updateDate}
                </tr>

            </div>
        </Container>

    );


}



